import { ViewIds } from '@ardoq/api-types';
import { ImageSrc } from '@ardoq/data-model';
import {
  ViewpointModeViewKey,
  ViewpointModeViewSettingsShapeWithoutSymbols,
  WorkspaceModeViewKey,
  WorkspaceModeViewSettingsShape,
} from 'views/environmentals/viewSettings/types';

export const MAIN_PANE_LEFT = 'MAIN_PANE_LEFT';
export const MAIN_PANE_RIGHT = 'MAIN_PANE_RIGHT';
export type PaneLocation = typeof MAIN_PANE_LEFT | typeof MAIN_PANE_RIGHT;

export type ViewSettings =
  | WorkspaceModeViewSettingsShape[WorkspaceModeViewKey]
  | ViewpointModeViewSettingsShapeWithoutSymbols[ViewpointModeViewKey]
  | Record<string, never>;

export enum MetaInfoViewStatus {
  NONE,
  NEW,
  BETA,
  SOON_TO_BE_DISCONTINUED,
  DISCONTINUED,
}
export interface MetaInfo {
  id: ViewIds;
  name?: string;
  description?: string;
  exampleImage?: ImageSrc;
  loadModule?: () => any;
  features?: {
    hasLegend: boolean;
  };
  isHiddenInViewSelect?: boolean;
  viewStatus?: MetaInfoViewStatus;
  killDate?: Date;
  deprecationSuccessor?: ViewIds;
}
